import React, { useState } from 'react';
import IconMap from '../../icons/IconMap';
import Button from '../../elements/Button';
import { Card, Group, Text } from '@mantine/core';
import styles from './styles.scoped.css';
import IcMap from '../../icons/IcMap';
import ModalMap from '../ModalMap';
import PropTypes from 'prop-types';

const CardCoordinateMerchant = ({
  data = {
    coordinate: {
      latitude: 0,
      longitude: 0,
    }
  }
}) => {
//   const centerPoint = {
//     lat: parseFloat(data?.coordinate?.split(',')[0]),
//     lng: parseFloat(data?.coordinate?.split(',')[1]),
//   }; 34.052235, -118.243683
  const centerPoint = {
    lat: data?.coordinate?.latitude || -6.200000,
    lng: data?.coordinate?.longitude || 106.816666,
  };

  const [showMap, setShowMap] = useState(false);
  return (
    <Card mb={10} radius="md" withBorder>
      <Card.Section inheritPadding py="xs" withBorder>
        <Group position="apart">
          <Text fw={500} fz={18}>Titik Koordinat</Text>
          <p
            style={{ marginBlock: 0 }}>{`${data?.coordinate?.latitude || 'Tidak ada data'}, ${data?.coordinate?.longitude || 'Tidak ada data'}`}</p>
        </Group>
      </Card.Section>
      <div className={styles.mapContainer}>
        <IconMap />
        <Button
          className={styles.btnIcon}
          onClick={() => setShowMap(true)}
          outlined
        >
          <IcMap /> Tampilkan Map
        </Button>
      </div>
      <ModalMap
        centerPoint={centerPoint}
        setShowMap={setShowMap}
        showMap={showMap}
      />
    </Card>
  );
};

export default CardCoordinateMerchant;

CardCoordinateMerchant.propTypes = {
  data: PropTypes.object
};
